import ExtendableError from 'es6-error';

/**
 * Generic Api error.
 */
export class ApiError extends ExtendableError {
  constructor(message, response) {
    super();
    this.response = void 0;
    this.message = message;
    this.response = response;
  }
}

/**
 * Throw this error if we are not loggged when trying to make an API request.
 */
export class ApiAuthError extends ApiError {}

/**
 * Throw this error if a fetch request failed because of a network error.
 */
export class NetworkError extends ApiError {}

/**
 * Throw this error if the status code is out of the range 200 to 299, exclusive
 */
export class ServerError extends ApiError {}

/**
 * Throw this error if the response is `opaque`
 * https://fetch.spec.whatwg.org/#concept-filtered-response-opaque
 */
export class OpaqueResponseError extends ApiError {}

/**
 * Throw this error if the response can't be formated
 */
export class BadRequestError extends ApiError {}

/**
 * Throw this error if the request is not correctly formated
 */
export class EmptyRequestError extends ApiError {}

/**
 * Throw this error when you have a valid error from the API
 */
export class CustomApiError extends ApiError {
  constructor(name, message, response) {
    super(message, response);
    this.payload = void 0;
    this.name = name;
    this.payload = response && typeof response === 'object' && 'payload' in response ? response.payload : void 0;
  }
}
//# sourceMappingURL=errors.js.map